export const toNumberSafe = (v) =>
    (v === '' || v == null ? 0 : Number(v));

export const toGrams = (val, unit) =>
    unit === 'kg'
        ? Math.round(toNumberSafe(val) * 1000)
        : Math.round(toNumberSafe(val));

export function toKey(x) {
    if (!x) return '';

    if (typeof x === 'string') {
        return x.replace(/^\/+/, '');
    }

    return String(x.key || x.url || '').replace(/^\/+/, '');
}

export function toSingleKey(arr) {
    const a = Array.isArray(arr) ? arr : [];
    const key = a.map(toKey).filter(Boolean)[0];
    return key || '';
}

const NAMED_COLORS = {
    orange: '#ffa500',
    black: '#000000',
    white: '#ffffff',
    red: '#ff0000',
    green: '#008000',
    blue: '#0000ff',
    yellow: '#ffff00',
    gray: '#808080',
    grey: '#808080',
};

export function normalizeHexColor(value, fallback = '#E8EEF7') {
    const raw = String(value ?? '').trim().toLowerCase();
    if (!raw) return fallback;

    if (/^#[0-9a-f]{6}$/i.test(raw)) return raw;

    if (/^#[0-9a-f]{3}$/i.test(raw)) {
        const [, r, g, b] = raw;
        return `#${r}${r}${g}${g}${b}${b}`;
    }

    return NAMED_COLORS[raw] || fallback;
}

export function makeInitialSnapshot(p = {}) {
    const grams = Number(p.weightGrams || 0);

    const unit =
        grams >= 1000 && grams % 1000 === 0
            ? 'kg'
            : 'g';

    const val = grams
        ? (unit === 'kg'
            ? String(grams / 1000)
            : String(grams))
        : '';

    /* ===== images ===== */

    const imgs = Array.isArray(p.images) ? p.images : [];

    const firstKey =
        typeof imgs[0] === 'string'
            ? imgs[0]
            : (imgs[0]?.key || imgs[0]?.url || '');

    // fallback для старого формату продукту
    const fallbackImage =
        typeof p.image === 'string'
            ? p.image
            : '';

    const productImage =
        (firstKey || fallbackImage || '')
            .replace(/^\/+/, '');

    return {
        title: p.name || '',
        brandId: p.brandId || '',
        flavor: p.flavor || '',
        flavorColor: normalizeHexColor(p.flavorColor),
        weightValue: val,
        weightUnit: unit,
        productImage,
        isAvailable:
            p.isAvailable == null
                ? true
                : !!p.isAvailable,
        descriptionHtml: p.description || '',
    };
}